













































































































































































import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import {
  DepositLogViewModel,
  DepositLogMoveFundsViewModel,
} from '@/models/filebunker/depositlog';
import { Utils } from '@/helper/utils';
import { Base } from '@/components/common/base';
import {
  VantivRefundViewModel,
} from '@/models/payment/paymentreport';
import { IDialogOption } from '@/models/dialog';
import { DateTimeHelper as _dateTime } from '@/helper/date-time.helper';
import {
  DepositLogNoteDataViewModel
} from '@/Alynk.dtos';
import {
  depositLogService,
  paymentReportService,
  repairOrderService,
  storeService,
} from '@/shared';
import { mapGetters } from 'vuex';
import { RoleType } from '@/helper/enum';
import { PaymentDetailViewModel } from '@/models/fixedops/repairorder';
import { NotificationType } from '@/helper/enum';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    ...mapGetters({ currentRoles: 'getRoles' }),
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Note: () => import('./note.component.vue'),
    Datepicker: () => import('@/components/common/app.datepicker.vue'),
  },
})
export default class DepositLogListPage extends Base {
  public refundPreset: any[] = [];
  public identifier: string = 'DEPOSIT LOG';
  public accountNumber: any = '';
  public hideAccountNumber: boolean = false;
  public selectedAccountNumber: string = '';

  public $moment: any;
  public paginations = new PaginationModel('createdAt', true);
  public pagedDepositLogs: DepositLogViewModel[] = [];
  public loading: boolean = false;
  public searched: boolean = false;
  public paymentToMoveFund: DepositLogMoveFundsViewModel = {};
  public fromDate: string = this.currentDate(new Date());
  public showFromDatePicker: boolean = false;
  public recordKey: string = '';
  public notesJson: DepositLogNoteDataViewModel[] = [];
  public noteDialog: boolean = false;
  public liveGlBalance: number = 0;
  public isFiltered: boolean = true;
  public isLiveGlBalanceLoading: boolean = false;
  public paymentProvider: string = '';
  public modelValue: any;
  public refundAction: any;
  public currentRoles: string[];
  public isRefundAllowed: boolean = false;
  public refund: VantivRefundViewModel = {};
  public paymentToRefund: PaymentDetailViewModel = {};

  public showRefundPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      'repairOrderPaymentReport.refundDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderPaymentReport.refundDialog.btnSubmit'
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.confirmRefund();
    },
    onClose: (): void => {
      this.clear();
    },
  };

  public clear() {
    this.refundPreset = [];
    this.accountNumber = '';
    this.selectedAccountNumber = '';
    this.getRefundPreset();
    this.getAccountNumber();
  }

  public confirmRefundDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('dialogSettings.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('dialogSettings.btntxtAgree') as string,
      disable: false,
    },
    onAction: (): void => {
      this.runRefund();
    },
  };

  public headers: VHeaders[] = [
    {
      text: this.$parent.$t(
        'depositLogList.gridHeaders.depositLogsId'
      ) as string,
      align: 'left',
      value: 'depositLogsId',
      sortable: false,
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.firstName') as string,
      align: 'left',
      value: 'depositLogJson.firstName',
      sortable: false,
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.lastName') as string,
      align: 'left',
      value: 'depositLogJson.lastName',
      sortable: false,
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.phoneNumber') as string,
      align: 'left',
      value: 'depositLogJson.phoneNumber',
      sortable: false,
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.date') as string,
      sortable: true,
      align: 'center',
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.comments') as string,
      align: 'left',
      value: 'depositLogJson.comments',
      sortable: false,
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.amount') as string,
      align: 'right',
      value: 'depositLogJson.amount',
      sortable: false,
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.age') as string,
      align: 'left',
      value: 'age',
      sortable: false,
    },
    {
      text: 'Payment Status',
      align: 'center',
      value: 'paymentStatus',
      sortable: false,
    },
    {
      text: this.$parent.$t('depositLogList.gridHeaders.createdBy') as string,
      align: 'left',
      value: 'createdByEmail',
      sortable: true,
    },
    {
      text: 'GL Balance' as string,
      align: 'left',
      value: 'dmsLiveBalance',
      sortable: false,
    },
    {
      text: this.$parent.$t(
        'depositLogList.gridHeaders.liveGlBalance'
      ) as string,
      align: 'left',
      value: 'liveGlBalance',
      sortable: false,
      fieldType: 'button',
      class: 'btn btn--icon',
      icon: { class: 'fas fa-eye', color: 'primary' },
      title: 'View Balance',

      onClick: (item) => {
        this.showLiveGlBalance(item);
      },
    },
    {
      align: 'center',
      text: 'Actions',
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public showMoveFundPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t('depositLogList.fundPopup.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('depositLogList.fundPopup.lblSubmit') as string,
      disable: false,
    },
    loading: false,
    onAction: (): void => {
      this.processMoveFunds();
    },
  };
  public showLiveGlBalancePopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t('depositLogList.glBalancePopup.title') as string,
    model: false,
    loading: false,
  };

  public actions: any[] = [];
  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fas fa-undo-alt',
        title: this.$t(
          'depositLogList.gridHeaders.gridAction.refund'
        ) as string,
        align: 'left',
        disable: (model: DepositLogViewModel) => {
          if (model.depositLogJson.glRefundStatus) {
            return true;
          }
          return false;
        },
        action: (model: DepositLogViewModel, action: any) => {
          this.refund.transactionAmount = model.depositLogJson.amount;
          this.showRefund(model, action);
          return ``;
        },
      },
      {
        type: 'button',
        icon: 'fas fa-redo-alt',
        title: this.$t(
          'depositLogList.gridHeaders.gridAction.moveFunds'
        ) as string,
        align: 'left',
        disable: (model: DepositLogViewModel) => {
          if (model.depositLogJson.glMoveFundStatus) {
            return true;
          }
          return false;
        },
        action: (model: DepositLogViewModel, action: any) => {
          this.showMoveFund(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-clipboard-list',
        title: this.$t('depositLogList.gridHeaders.gridAction.notes') as string,
        action: (model: DepositLogViewModel, action: any) => {
          this.viewNote(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-eye',
        title: 'View Receipt',
        color: 'primary',
        visible: (model: any) => {
          if (this.paymentProvider == 'Square') {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.downloadReceipt(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-link',
        title: 'Resend Payment Link',
        color: 'primary',
        visible: (model: any) => {
          if (model.paymentStatus != 'Approved' && model.isPaymentLink) {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.reSendPaymentLink(model);
        },
      },
    ];
  }
  public viewNote(props: DepositLogViewModel): void {
    this.recordKey = props.id.toString();
    if (props.notesJson !== undefined) {
      this.notesJson = props.notesJson;
    } else {
      this.notesJson = [];
    }
    this.noteDialog = true;
  }
  public closeNote(val: boolean): void {
    this.noteDialog = val;
  }

  public currentDate(date?): string {
    if (!date && typeof date !== 'function') {
      date = new Date();
    }
    let month = (date.getMonth() + 1).toString();
    if (Number(month) < 10) {
      month = '0' + month;
    }
    const d = `${date.getFullYear()}-${month}-${date.getDate()}`;
    return d;
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addDepositLog') {
      this.addDepositLog();
    }
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('depositLogList.btnDepositLog'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('depositLogList.btnDepositLog'),
      click: 'addDepositLog',
      icon: 'fas fa-plus-circle',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }

  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'depositLogs');
    this.getRefundPreset();
    // toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    this.setActions();
    if (this.$route.query.showPending) {
      this.isFiltered = Boolean(
        JSON.parse(this.$route.query.showPending.toString())
      );
    }
    const pagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (pagination) {
      this.paginations = pagination;
    }
    this.getDefaultPaymentType();
    this.getDepositLogs();

    const roles = this.currentRoles;
    if (roles.indexOf(RoleType.AllowRefund) > -1) {
      this.isRefundAllowed = true;
    }
  }

  public async getRefundPreset(): Promise<void> {
    try {
      const refundPresets = await storeService.getRefundPresst(this.identifier);
      this.refundPreset = refundPresets;
    } finally {
    }
  }

  public getAccountNumber() {
    try {
      this.loading = true;
      this.hideAccountNumber = true;
      const account = this.refundPreset.filter(
        (item) => item.id == this.selectedAccountNumber
      );
      this.accountNumber = account[0].accountNumber;
    } finally {
      this.loading = false;
    }
  }

  public addDepositLog() {
    this.$router.push({ name: 'app.depositlogs.add' });
  }

  public getFilteredRecord() {
    this.paginations.page = 1;
    const queryStringObj = Object.assign({}, this.paginations) as any;
    queryStringObj.showPending = this.isFiltered;
    Utils.validateAndUpdateRoute(queryStringObj);
    this.getDepositLogs();
  }

  public runRefund(): void {
    this.showRefundPopup.model = false;
    this.processRefund(this.modelValue, this.refundAction);
  }

  public async getDepositLogs(): Promise<void> {
    try {
      this.loading = true;
      const depositLogs = await depositLogService.getDepositLogsAllAsync(
        this.paginations,
        this.isFiltered ? 1 : 0
      );
      this.pagedDepositLogs = depositLogs.results;
      this.paginations.totalItems = depositLogs.total;
    } finally {
      this.loading = false;
    }
  }
  public updatePaging(paging: PaginationModel) {
    this.paginations = paging;
    const data = Object.assign({}, paging) as any;
    const routPagination = Utils.getPaginationFromRouteQuery(this.$route.query);
    if (
      routPagination == undefined ||
      paging.page != routPagination.page ||
      paging.descending != routPagination.descending ||
      paging.sortBy != routPagination.sortBy
    ) {
      if (data) {
        data.showPending = this.isFiltered;
      }
      history.replaceState(
        {},
        "",
        window.location.href.split('?')[0] + '?' + Utils.getQueryString(data)
      );
    }
    this.getDepositLogs();
  }

  public showMoveFund(model: DepositLogViewModel): void {
    this.paymentToMoveFund = {};
    this.paymentToMoveFund.id = model.id;
    this.paymentToMoveFund.stockNumber = '';
    this.paymentToMoveFund.date = this.currentDate(new Date());
    this.showMoveFundPopup.model = true;
  }

  public showRefund(model: DepositLogViewModel, action: any): void {
    this.modelValue = model;
    this.paymentToRefund.approvedAmount = Number(model.depositLogJson.amount);
    this.refundAction = action;
    this.showRefundPopup.model = true;
    this.getAccountNumber();
  }

  public confirmRefund(): void {
    if (this.refund.transactionAmount > this.paymentToRefund.approvedAmount) {
      this.showAlert(
        false,
        'Refund Amount Can not be greater than Paid Amount , Or please Refresh if you have already processed refund'
      );
      return;
    }

    var accountDetails = this.refundPreset.filter(
      (x) => x.id == this.selectedAccountNumber
    )[0];
    if (
      accountDetails != null &&
      accountDetails != undefined &&
      !accountDetails.isDmsPostAllowed
    ) {
      this.showAlert(
        false,
        'As per selected configuration debit and credit Account/Control details are same , So Transaction is not allowed.'
      );
      return;
    }

    this.confirmRefundDialog.model = true;
  }

  public async processRefund(
    model: DepositLogViewModel,
    action: any
  ): Promise<void> {
    try {
      this.confirmRefundDialog.action.disable = true;
      action.loading = true;
      if (this.isRefundAllowed) {
        await depositLogService.refundAsync(
          model.id,
          this.selectedAccountNumber,
          this.refund.transactionAmount,
          ''
        );
        model.depositLogJson.glRefundStatus = true;
        this.showAlert(true, this.$t('depositLogList.alertRefundSuccess'));
        this.refundPreset = [];
        this.accountNumber = '';
        this.selectedAccountNumber = '';
        this.refund.transactionAmount = '';
      } else {
        this.showAlert(
          false,
          'You are not allowed refund, Please contact Admin'
        );
      }
    } catch (ex) {
      console.log(ex);
      action.loading = false;
    } finally {
      action.loading = false;
      this.confirmRefundDialog.action.disable = false;
      this.confirmRefundDialog.model = false;
    }
  }

  public async processMoveFunds(): Promise<void> {
    try {
      const vm = this;
      if (
        !this.paymentToMoveFund.id ||
        !this.paymentToMoveFund.stockNumber ||
        !this.paymentToMoveFund.date
      ) {
        this.showAlert(false, this.$t('depositLogList.alertSufficientDetails'));
        return;
      }
      this.showMoveFundPopup.action.disable = true;
      this.showMoveFundPopup.loading = true;
      const response = await depositLogService.moveFundsAsync(
        this.paymentToMoveFund.id,
        this.paymentToMoveFund.stockNumber,
        this.paymentToMoveFund.date
      );

      const depositLog = this.pagedDepositLogs.filter((item) => {
        return item.id === vm.paymentToMoveFund.id;
      })[0];
      depositLog.depositLogJson.glMoveFundStatus = true;
      this.showAlert(true, this.$t('depositLogList.alertMoveFund'));
      this.showMoveFundPopup.model = false;
    } finally {
      this.showMoveFundPopup.action.disable = false;
      this.showMoveFundPopup.loading = false;
    }
  }

  public async showLiveGlBalance(depositLog): Promise<void> {
    try {
      // On Production there are 50 records till, 16-Jan-2020 at 5:40 PM IST
      if (depositLog.id <= 50) {
        this.showAlert(false, this.$t('depositLogList.alertGlBalance'));
        return;
      }
      this.isLiveGlBalanceLoading = true;
      this.showLiveGlBalancePopup.model = true;
      this.showLiveGlBalancePopup.loading = true;
      const response = await depositLogService.getLiveGLBalance(
        depositLog.depositLogsId
      );
      depositLog.liveGlBalance = response.liveGLBalance;
      this.liveGlBalance = depositLog.liveGlBalance;
    } finally {
      this.isLiveGlBalanceLoading = false;
      this.showLiveGlBalancePopup.loading = false;
    }
  }

  public setFromDateValue(date: any): void {
    this.fromDate = date;
    this.paymentToMoveFund.date = this.fromDate;
  }

  public async downloadReceipt(request): Promise<void> {
    try {
      const response = await paymentReportService.downloadReceipt(
        request.depositLogJson.transactionHeaderId,
        request.depositLogJson.lastPaymentDetailId,
        request.paymentType
      );
    
      if (response?.fileDownloadName) {
        window.open(response.fileDownloadName, '_blank');
      } else {
        this.showNotification(NotificationType.Warning, "Receipt is not available for this transaction.");
      }
    } finally {
      // finally block
    }
  }

  public async reSendPaymentLink(request): Promise<void> {
    try {
      const response = await depositLogService.reSendPaymentLink(
        request.depositLogJson.transactionHeaderId,
        request.depositLogJson.lastPaymentDetailId,
      );
      this.showAlert(true, "Payment link has been sent");
    } finally {
      // finally block
    }
  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      const result = await repairOrderService.getDefaultPaymentProvider();
      this.paymentProvider = result.paymentProvider;
    } finally {
      // finally block
    }
  }
}
